module.exports = __webpack_public_path__ + "static/media/2.ac029509.jpg";